<template>
  <PlanSummaryCardText
    :showCouponBadge="hasAppliedCoupon"
    :title="planSummaryTitle"
    :pricing="planPricing"
    :strikethroughPricing="strikethroughPricing"
    :subheading="subheading"
    :secondarySubheading="pricingSubheading"
    :trialInfo="trialDisplay"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { useCouponStore } from '@/store/CouponStore'
import { usePlanStore } from '@/store/PlanStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
import { useSubscriptionStore } from '@/store/SubscriptionStore'
const checkoutStore = useCheckoutStore()
const planStore = usePlanStore()
const priceStore = usePriceStore()
const productStore = useProductStore()
const couponStore = useCouponStore()
const subscriptionStore = useSubscriptionStore()
const { country } = storeToRefs(checkoutStore)
const { isInTrial } = storeToRefs(subscriptionStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice, selectedPlanDisplayUnitPrice } = storeToRefs(priceStore)

const { selectedPlanIntervalAsNoun, selectedPlanLengthDisplay } = storeToRefs(planStore)

const { hasAppliedCoupon, couponDuration, isTemporalCoupon, isForeverCoupon, isSingleUseDiscountCoupon } = storeToRefs(couponStore)

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)
const subheading = computed(() => `${trialEmailDisplay.value} Cancel anytime.`)

const strikethroughPricing = computed(() => selectedPlanDisplayUnitPrice.value)
const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value} ${durationDisplay.value}`)

const duration = computed(() => {
  if (isTemporalCoupon.value) {
    return couponDuration.value
  } else if (isSingleUseDiscountCoupon.value) {
    return selectedPlanLengthDisplay.value
  }
  return ''
})

const pricingSubheading = computed(
  () => `${selectedPlanDisplayUnitPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value} ${subheadingDurationDisplay.value}`
)
const subheadingDurationDisplay = computed(() => (isForeverCoupon.value ? '' : `after ${duration.value}`))
const durationDisplay = computed(() => (isForeverCoupon.value ? '' : `for ${duration.value}`))

const trialDisplay = computed(() => (isInTrial.value ? 'once your trial ends.' : 'starting today.'))
const trialEmailDisplay = computed(() => (isInTrial.value ? "We'll remind you three days before your trial ends." : ''))
</script>
